<template>
  <div>
    <div class="" v-if="!isDataFetched">
      <div class="loader">
        <base-loader/>
      </div>
    </div>
    <div class="container">
      <!-- <div class="billing-row">
        <button class="billing-button" @click.prevent="openCustomerPortal">
            Billing Portal
        </button>
      </div> -->
      <h2>Billing</h2>
      <div class="table">
        <div class="table-row">
          <div class="col col_left">
            <label>
                Organization Name
            </label>
          </div>
          <div class="col col_flex">
            <label>
              {{  agencyData.name }}
            </label>
          </div>
        </div>
        <div class="table-row">
          <div class="col col_left">
            <label>
                Account Standing
            </label>
          </div>
          <div class="col col_flex">
              <!-- {{  billingData.stripe_account_standing ? 'Active' : 'Inactive' }} -->
              <BaseBadge
                v-if="!isSubscriptionCanceled"
                label="Active"
                type="vibrant"
              />
              <BaseBadge
                v-else
                :label="expirationDateLabel"
                type="muted"
              />
          </div>
        </div>
        <div class="table-row">
          <div class="col col_left">
            <label>
                Active Projects
            </label>
          </div>
          <div class="col col_flex">
            <label>{{  agencyData.project_count && agencyData.project_count.toLocaleString() }}</label>
          </div>
        </div>
        <div class="table-row">
          <div class="col col_left">
            <label>
                Active Keywords
            </label>
          </div>
          <div class="col col_flex">
            <label>{{  agencyData.keyword_count && agencyData.keyword_count.toLocaleString() }}</label>
          </div>
        </div>
        <div class="table-row">
          <div class="col col_left">
            <label>
                Current Subscription
            </label>
          </div>
          <div class="col col_flex col_visible-overflow">
            <base-select v-model="data.stripe_product_id" class="subscription-select"
              :border-less="true"
              :options="stripeProductsList" :max-height-list="450"/>
          </div>
        </div>
      </div>
      <!-- <div class="button-left">
        <button class="billing-button billing-button_save" @click.prevent="openCustomerPortal">
            Manage Billing
        </button>
      </div> -->
      <div class="billing__buttons-holder">
        <button class="billing-button billing-button_cancel" @click.prevent="openCustomerPortal">
            Cancel Subscription
        </button>
        <span class="billing__help-text">For help with your subscription, contact <a href="mailto:support@audiencekey.com">support@audiencekey.com</a></span>
        <button class="billing-button billing-button_manage" @click.prevent="openCustomerPortal">
            Manage Billing
        </button>
        <button class="billing-button billing-button_save" @click.prevent="updateSelectedProduct">
            Save
        </button>
      </div>
      <h2>Subscriptions Available</h2>
      <div class="table table_subscriptions">
        <div class="table-row">
          <div class="col col_left">
            <label>
                Plan Name
            </label>
          </div>
          <div class="col col_left">
            <label>
              Monthly Cost
            </label>
          </div>
          <div class="col col_left">
            <label>
              Keywords Included
            </label>
          </div>
          <div class="col">
            <label>
              Additional Keyword Cost
            </label>
          </div>
        </div>
        <div class="table-row">
          <div class="col col_left">
            <span>
                Audience Key Pro
            </span>
          </div>
          <div class="col col_left">
            <span>
              $179
            </span>
          </div>
          <div class="col col_left">
            <span>
              3,000
            </span>
          </div>
          <div class="col">
            <span>
              $0.0350
            </span>
          </div>
        </div>
        <div class="table-row">
          <div class="col col_left">
            <span>
                Audience Key Enterprise
            </span>
          </div>
          <div class="col col_left">
            <span>
              $549
            </span>
          </div>
          <div class="col col_left">
            <span>
              15,000
            </span>
          </div>
          <div class="col">
            <span>
              $0.0320
            </span>
          </div>
      </div>
      <div class="table-row">
        <div class="col col_left">
          <span>
              Audience Key Lite
          </span>
        </div>
        <div class="col col_left">
          <span>
            $39
          </span>
        </div>
        <div class="col col_left">
          <span>
            500
          </span>
        </div>
        <div class="col">
          <span>
            $0.0600
          </span>
        </div>
      </div>
      <div class="table-row">
        <div class="col col_left col_flex">
          <span>
              Audience Key Agency Multi Projects
          </span>
        </div>
        <div class="col col_flex">
          <span>
          </span>
        </div>
        <div class="col col_flex">
          <span>
            Contact support@audiencekey.com
          </span>
        </div>
        <div class="col col_flex">
          <span>
          </span>
        </div>
      </div>
      </div>
      <!-- <h2>Cancel Subscription</h2>
      <CancelSubscriptionForm @subscriptionCanceled="handleSubscriptionCanceled" 
      `  :isSubscriptionCanceled="isSubscriptionCanceled" /> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import baseModalProps from '@/common/BaseModalProps'
// import CancelSubscriptionForm from './CancelSubscriptionForm'
export default {
  name: 'BillingDashboard',
  // components: { CancelSubscriptionForm },
  data () {
    return {
      data: {},
      isDataFetched: false,
      isDataUpdating: false,
      disableButtons: false,
      errorFields: {
        name: false,
        email: false
      },
      isSubscriptionCanceledmanually: false,
    }
  },
  watch: {
    billingData () {
      this.data = this.billingData
    },
    clientId: {
      handler(v) {
        if (v) {
          this.isDataFetched = false
          this.getAgency({ clientId: v }).then(() => {
            this.isDataFetched = true
          })
        }
      },
      immediate: true
    }
  },
  async mounted() {
    await this.getAgency({ clientId: this.clientId })
    this.isDataFetched = true
  },
  computed: {
    ...mapState('agency', ['agencyData', 'billingData']),
    ...mapState(['userGroups', 'stripeProducts', 'stripe']),
    modalProps () {
      return { ...baseModalProps, height: 'auto', width: '75%' }
    },
    userGroupsList () {
      return this.userGroups['user_plan_group'].map(group => {
        return {
          label: group.name,
          value: group.id
        }
      }) 
    },
    expirationDateLabel () {
      // get date from days remaining
      // if days remaining is 0, return 'Expired'
      if (this.billingData.days_remaining === 0) {
        return 'Expired'
      }
      const date = new Date()
      date.setDate(date.getDate() + this.billingData.days_remaining)
      // get as MMM dd YYYY
      return `Expiring ${date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`
    },
    currentPlan () {
      return this.userGroupsList.find(group => group.value === this.data.user_group_id)
    },
    stripeProductsList () {
      return this.stripeProducts.map(product => {
        return {
          label: product.name,
          value: product.id
        }
      })
      const currentPlanProducts = this.getProductsByPlanId(this.data.user_group_id)
      let lowerPlanProducts = []
      let higherPlanProducts = []
      if (this.currentPlan?.label === 'Free Trial') {
        const litePlanId = this.userGroupsList.find(group => group?.label === 'Lite')?.value
        higherPlanProducts = this.getProductsByPlanId(litePlanId)
        const proPlanId = this.userGroupsList.find(group => group?.label === 'Paid - Pro')?.value
        higherPlanProducts = [ ...higherPlanProducts, ...this.getProductsByPlanId(proPlanId)]
      } else if (this.currentPlan?.label === 'Lite') {
        const proPlanId = this.userGroupsList.find(group => group?.label === 'Paid - Pro')?.value
        higherPlanProducts = this.getProductsByPlanId(proPlanId)
      }  else if (this.currentPlan?.label === 'Paid - Pro') {
        const litePlanId = this.userGroupsList.find(group => group?.label === 'Lite')?.value
        lowerPlanProducts = this.getProductsByPlanId(litePlanId)
        const agencyPlanId = this.userGroupsList.find(group => group?.label === 'Paid - Agency')?.value
        higherPlanProducts = this.getProductsByPlanId(agencyPlanId)
      }
      return [...lowerPlanProducts, ...currentPlanProducts, ...higherPlanProducts].map(product => {
        return {
          label: product.name,
          value: product.id
        }
      })

    },
    isSubscriptionCanceled () {
      return !this.billingData.stripe_account_standing || this.billingData.days_remaining !== null || this.isSubscriptionCanceledmanually
    }
  },
  methods: {
    ...mapActions('agency', ['getAgency', 'updateBillingData', 'updateSubscription']),
    ...mapActions(['getCurrentSession', 'updateSelectedClientData']),
    // async updateUserPlanGroup () {
    //   this.updatePlanGroup(this.data.user_group_id)
    // },
    async updateSelectedProduct () {
      await this.updateSubscription(this.data.stripe_product_id)
      this.getAgency({ clientId: this.clientId })
    },
    getProductsByPlanId (planId) {
      return this.stripeProducts.filter(product => product.fk_user_group_id === planId)
    },
    resetErrors () {
      for (const k in this.errorFields) {
        this.errorFields[k] = false
      }
    },
    openCustomerPortal () {
      const url = `https://billing.stripe.com/p/login/dR66qv6L9eoCcxi3cc?prefilled_email=${encodeURIComponent(this.agencyData.email)}`
      window.open(url, '_blank').focus()
    },
    async updateBilling () {
      this.resetErrors()
    },
    handleSubscriptionCanceled () {
      this.isSubscriptionCanceledmanually = true
    }
  }
}
</script>

<style scoped lang="scss">

    .billing__help-text {
      font-size: 14px;
      color: $rfx-dark-march;
      margin-right: auto;
      margin-left: 10px;
      a {
        color: $rfx-dark-march;
        // text-decoration: none;
      }
    }
    .inactive-billing-link {
      color: $rfx-warning-red;
      cursor: pointer;
    }
    .col {
      width: 50%;
      &_left {
        border-right: 1px solid $rfx-light-steel;
      }
      &_flex {
        display: flex;
        align-items: center;
        padding: 0 10px;
        box-sizing: border-box;
        overflow: hidden;

        label, 
        span {
          margin: 0;
        }

        .subscription-select {
          margin-left: -10px;
          &::v-deep .select__selection {
            padding-left: 10px;
          }
        }
      }

      &_visible-overflow {
        overflow: visible;
      }
    }
    .billing-row {
      align-self: flex-end;
    }
    .billing__buttons-holder {
      display: flex;
      justify-content: flex-end;
      gap: 8px;
      border: 1px solid $rfx-medium-steel;
      border-top: none;
      padding: 12px;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
    .billing-button {
        // &_save {
        //   margin-top: 2vh;
        // }
        min-width: 100px;
        padding: 0 25px;
        height: 40px;
        font-size: 10px;
        font-weight: 900;
        cursor: pointer;
        text-transform: uppercase;
        border-radius: 8px;
        outline: none;
        border: none;
        color: #fff;
        background-color: $rfx-dark-march;

        &_manage,
        &_cancel {
          background-color: transparent;
          border: 1px solid $rfx-medium-steel;
          color: $rfx-dark-march;

          &:hover {
            border-color: $rfx-dark-march;
          }
        }

        &_cancel {
          margin-right: auto;
        }
    }
    .container {
      display: flex;
      flex-direction: column;
      margin: 0 15vw;
    }
    
    h2 {
      margin-top: 5vh;
    }
    .table {
        border-top: 1px solid $rfx-light-steel;
        border-right: 1px solid $rfx-light-steel;
        border-left: 1px solid $rfx-light-steel;
        display: flex;
        flex-direction: column;
        background-color: #FFF;
        border-radius: $rfx-default-border-radius;
        padding: 0;
    }
    .table-row {
        height: 55px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid $rfx-light-steel;
    }
    span {
        // width: 50%;
        display: inline-block;
        margin: 15px 0 15px 10px;
    }
    label {
        // width: 50%;
        display: inline-block;
        color: $rfx-dark-march;
        font-weight: bold;
        margin: 15px 0 15px 10px;
    }
    input {
        padding: 0 20px;
        border: none;
        outline: none;
        width: 50%;
    }
    input:disabled {
      background-color: inherit;
    }

    input.error {
      background-color: #ffdddd;
    }
    .row-span {
      width: 50%;
      padding: 10px 20px;
    }
    .link {
      text-decoration: none;
      color: $rfx-bright-blue;
      cursor: pointer;
      width: 50%;
      padding: 10px 20px;
    }
    .loader {
      display: flex;
      position: fixed;
      padding-top: 20vh;
      width: 100%;
      justify-content: center;
      align-items: flex-start;
      height: 100vh;
      background-color: rgba(255, 255, 255, .7);
    }
</style>
